__turbopack_context__.v({
  "arrow": "ArticleCard-module-scss-module__ns5z8G__arrow",
  "date": "ArticleCard-module-scss-module__ns5z8G__date",
  "excerpt": "ArticleCard-module-scss-module__ns5z8G__excerpt",
  "icon": "ArticleCard-module-scss-module__ns5z8G__icon",
  "image": "ArticleCard-module-scss-module__ns5z8G__image",
  "image-container": "ArticleCard-module-scss-module__ns5z8G__image-container",
  "main": "ArticleCard-module-scss-module__ns5z8G__main",
  "pattern": "ArticleCard-module-scss-module__ns5z8G__pattern",
  "pdf": "ArticleCard-module-scss-module__ns5z8G__pdf",
  "title": "ArticleCard-module-scss-module__ns5z8G__title",
  "top": "ArticleCard-module-scss-module__ns5z8G__top",
});
